const t = {
  name: "SolutionData",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22 22V2H8V8H2V22H22ZM16 20V8H10V4H20V20H16ZM14 20H10V10H14V20ZM8 20H4V10H8V20Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as SolutionData
};
